module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M3.71 18.304l-.49 9.836a1.673 1.673 0 0 0 3.344 0V16.428c0-.114-.1-.184-.12-.292L3.71 18.304zm6.202-4.918v14.528c0 1.048.75 1.898 1.672 1.898.924 0 1.674-.848 1.674-1.898V15.148l-2.734-2.246-.612.484zm6.692 14.63c0 .992.75 1.796 1.672 1.796.924 0 1.672-.804 1.672-1.796v-7.372l-3.346-2.748v10.12zM26.63 14.328l-3.334 3.038V28.14a1.673 1.673 0 0 0 3.344 0V14.756c.002-.014-.01-.416-.01-.428z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/nutrients-secondary.js
// module id = 1312
// module chunks = 14